/*
 * Brand-specific presentation, shared by BrandChecker and the Brands pending panel.
 *
 * These are the ComparisonTable `formatValue` / `formatField` hooks: the brand screens keep
 * their human labels (Sponsored / Active rather than raw ids) while still going through the
 * same dispatcher + table as every other maker-checker screen.
 *
 * Rules preserved verbatim from the original BrandChecker renderer.
 */
import { brandLabels, BrandsTypes } from "../../../utils/constants";

// Not shown: brand_category is superseded by brand_category_label, and brand_logo_url is
// rendered as an image rather than a value.
export const BRAND_HIDDEN_FIELDS = ["brand_category", "brand_logo_url"];

export const brandFieldLabel = (field) => (field === "brand_category_label" ? "brand_category" : field);

// Returns undefined to defer to ComparisonTable's default renderer.
export const formatBrandValue = (field, value) => {
  const isEmpty =
    value === null || value === undefined || value === "" || (Array.isArray(value) && value.length === 0);
  if (isEmpty) return undefined; // default renderer shows an em-dash

  // Loose `==` is deliberate and carried over from the original renderer: the payload can
  // carry these as strings ("2") while the option lists hold numbers (2). Tightening this
  // to === would silently fall through to the raw id instead of the label.
  /* eslint-disable eqeqeq */
  if (field === "brand_type") return BrandsTypes.find((bt) => bt.value == value)?.label ?? String(value);
  if (field === "brand_label") return brandLabels.find((cat) => cat.value == value)?.label ?? String(value);
  /* eslint-enable eqeqeq */
  if (field === "status") return Number(value) === 1 ? "Active" : "Inactive";
  return undefined;
};

// Drops the hidden fields from normalized groups, and any group left empty.
export const omitBrandFields = (groups = []) =>
  groups
    .map((group) => ({ ...group, rows: group.rows.filter((row) => !BRAND_HIDDEN_FIELDS.includes(row.field)) }))
    .filter((group) => group.rows.length);
